module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Wolves.c60655a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Wolves.jpg
// module id = /jBy
// module chunks = 0